import { colors } from '../tokens';
import { layout } from '../tokens';

/** MUI Card override — borderRadius matches design system card radius, no shadow. */
const MuiCard = {
  styleOverrides: {
    root: {
      borderRadius: layout.cardRadius,
      boxShadow: 'none',
      backgroundColor: colors.background.paper,
    },
  },
};

export default MuiCard;
